
const API_URL = process.env.NODE_ENV === 'production'
	? process.env.REACT_APP_PRD_API_URL
	: process.env.REACT_APP_DEV_API_URL;

// api.js

export const count = async (client) => {
	if (!client) return "";
	const response = await fetch(`${API_URL}/counter/${client}`);
	return await response.text();
};

export const getByEnc = async (language, client, enc) => {
	const apiUrl = `${API_URL}/fines/${language}/${client}/?enc=${enc}`;
	const options = {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		}
	};

	return await fetch(apiUrl, options).then((response) => {
		if (response.status === 404 || response.status === 400) {
			return {
				error: "noresultfound",
				data: null
			};
		}
		return response.json().then((data) => ({
			data: data,
			error: null
		}));
	}).catch(err => {
		return {
			error: true,
			message: "noresultfound"
		};
	});
};

export const help = async (language, client) => {
	const response = await fetch(`${API_URL}/faq/${language}/${client}`);
	if (response.status === 404 || response.status === 204) return [];
	return await response.json();
};

export const translations = async (language = "en") => {
	const response = await fetch(`${API_URL}/translations/${language}`);
	const translations = await response.json();
	return translations;
};

export const searchOld = async (language, client, data) => {
	const apiUrl = `${API_URL}/fines/${language}/${client}`;
	data.license = data.license.replace(/-/g, '').replace(/ /g, '');
	const options = {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	};

	return await fetch(apiUrl, options).then((response) => {
		if (response.status === 404 || response.status === 400) {
			return {
				error: "noresultfound",
				data: null
			};
		}
		return response.json().then((data) => ({
			data: data,
			error: null
		}));
	}).catch(err => {
		return {
			error: true,
			message: "noresultfound"
		};
	});
};

export const search = async (language, client, data) => {
	const apiUrl = `${API_URL}/fines/${language}/${client}`;
	data.license = data.license.replace(/-/g, '').replace(/ /g, '');

	// 1. Maak een AbortController aan
	const controller = new AbortController();
	const { signal } = controller;

	// 2. Start een timer die de request na 10 seconden afbreekt
	const timeoutId = setTimeout(() => controller.abort(), 30000);

	const options = {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
		signal: signal, // 3. Geef het signal mee aan de fetch opties
	};

	return await fetch(apiUrl, options)
		.then((response) => {
			clearTimeout(timeoutId); // 4. Clear de timer zodra we antwoord hebben!

			if (response.status === 404 || response.status === 400) {
				return {
					error: "noresultfound",
					data: null
				};
			}
			return response.json().then((data) => ({
				data: data,
				error: null
			}));
		})
		.catch(err => {
			clearTimeout(timeoutId); // 5. Clear ook hier de timer voor de zekerheid

			// Controleer of de fout komt door de timeout (abort)
			if (err.name === 'AbortError') {
				return {
					error: true,
					message: "timeout" // Specifieke melding voor timeout
				};
			}

			return {
				error: true,
				message: "noresultfound"
			};
		});
};


export const get = async (language, client, id, key) => {
	let apiUrl = `${API_URL}/fines/${language}/${client}/${id}`;

	if (key != null)
		apiUrl = `${apiUrl}?enc=${key}`;

	return await fetch(apiUrl).then((response) => {
		if (response.status === 404 || response.status === 400) {
			return {
				error: true,
				message: "noresultfound",
			};
		}
		return response.json().then((data) => ({
			data: data,
			error: false,
		}));
	}).catch(err => {
		return {
			error: true,
			message: "noresultfound"
		};
	});
};
